import styled from 'styled-components';

export const Container = styled.div`
  width: auto;
  height: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #ccccca;
  padding: 2rem 0;
`;
